export default __webpack_public_path__ + "static/media/leftbg.7f9b9eca.jpg";